import { useMemo } from 'react';
import {
  percentFormatter,
  type PercentFormatterOptions,
} from 'react-formatted-input-hook';

import { useNumberLocalize } from './locales/useNumberLocalize.js';

export const usePercentFormatter = () => {
  const locales = useNumberLocalize();

  return useMemo(() => {
    return {
      format: (
        value: string | number,
        options: Omit<
          PercentFormatterOptions,
          'liveUpdate' | 'onChange' | 'value'
        > = {},
      ) => {
        const fmt = percentFormatter({
          locales,
          max: Infinity,
          min: -Infinity,
          ...options,
        });

        return fmt.format?.(fmt.onBlur?.(`${value}`) ?? '');
      },
    };
  }, [locales]);
};
